/* eslint-disable radix */
/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Geolocation from "react-geolocation"
import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import Select from "@components/anti/Forms/components/select"
import Link from "@components/anti/Link"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import { getAllCityList, getNearestoutlet, searchOutletByCityId } from "lib/api"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { imgUrl } from "src/mixins"
import { dataLayerCinemaLocation } from "lib/datalayer"
import SectionNotFound from "../SectionNotFound"

function SectionFindCinema1({
  getCurrentPosition,
  concessionId,
  cinemaId,
  latitude,
  longitude,
  anim,
  title,
}) {
  const Router = useRouter()
  const { locale } = Router
  const [state, setState] = useState({
    location: "jakarta",
    latitude: null,
    cityOptions: [],
    selectCity: null,
    cinemaDisplay: [],
    loading: false,
  })

  const getCinemaList = async (id, lat, lng) => {
    setState((prev) => ({ ...prev, loading: true }))
    const outlets = await searchOutletByCityId(
      parseInt(id),
      concessionId,
      cinemaId,
      { lat, lng }
    )
    setTimeout(() => {
      setState((prev) => ({
        ...prev,
        loading: false,
        cinemaDisplay: outlets?.length > 0 ? outlets : null,
      }))
    }, 250)
  }

  const getByGetLocation = async () => {
    const nearestOutlet = await getNearestoutlet(
      parseFloat(latitude),
      parseFloat(longitude),
      cinemaId,
      concessionId
    )
    if (nearestOutlet?.length) {
      const cityOptions = nearestOutlet.map((item) => ({
        label: item.name,
        value: item,
        ...item,
      }))
      getCinemaList(nearestOutlet[0].id, latitude, longitude)
      setState((prev) => ({ ...prev, cityOptions, selectCity: cityOptions[0] }))
    }
  }

  const getCityList = async () => {
    const variables = { cinema_id: cinemaId, concession_id: concessionId }
    if (!cinemaId) delete variables.cinema_id
    if (!concessionId) delete variables.concession_id
    const cityList = await getAllCityList({ variables })
    if (cityList?.length > 0) {
      const cityOptions = cityList.map((item) => ({
        label: item.name,
        value: item,
        ...item,
      }))
      const defaultCity =
        cityOptions?.find((item) => item?.id === 73) || cityOptions[0]
      getCinemaList(defaultCity?.id, defaultCity.lat, defaultCity.lng)
      setState((prev) => ({
        ...prev,
        cityOptions,
        selectCity: defaultCity,
      }))
    }
  }

  const selectCity = (value) => {
    setState((prev) => ({ ...prev, selectCity: value }))
    getCinemaList(value.value.id, latitude || value.lat, longitude || value.lng)
  }

  useEffect(() => {
    getCurrentPosition()
  }, [])

  useEffect(() => {
    if (latitude && longitude) {
      getByGetLocation()
    } else {
      getCityList()
    }
  }, [latitude, longitude])
  return (
    <>
      <div className="py-main">
        <div className="container">
          <div className="row row-title">
            <div className="col-md-6 col-title">
              <h2 className={`title ${anim(1)}`}>
                {locale === "en"
                  ? translations?.sc_find_cinema_title_en(title)
                  : translations?.sc_find_cinema_title_id(title)}
              </h2>
              <Link
                href="/locations"
                withArrow
                className={`text-capitalize ${anim(2)}`}
              >
                {translations[`sc_find_cinema_text_${locale}`]}
              </Link>
            </div>
            <div className="col-md-6 col-select">
              <div className={anim(3)}>
                <Select
                  iconLeft
                  iconRight
                  options={state.cityOptions}
                  value={state.selectCity}
                  onChange={(_, val) => {
                    selectCity(val)
                  }}
                />
              </div>
            </div>
          </div>
          {!state.loading ? (
            state.cinemaDisplay ? (
              <SliderSwiper
                loop={false}
                breakpoints={{
                  365: {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                  },
                  640: {
                    slidesPerView: 1.6,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                }}
                className="find-cinema-slider mt-4"
              >
                {state.cinemaDisplay?.map((item, i) => {
                  const iconGroup = []
                  if (item.is_3d)
                    iconGroup.push({ icon: "/img/icon/img_icon-3d.svg" })
                  if (item.is_thx)
                    iconGroup.push({ icon: "/img/icon/img_icon-thx.svg" })
                  if (item.is_dolby_atmos)
                    iconGroup.push({ icon: "/img/icon/img_icon-atmos.svg" })
                  return (
                    <SwiperSlide
                      key={`cinema-result-${i}-${item[`title_${locale}`]}`}
                    >
                      <div className={`${anim(4 + i)} pt-1`}>
                        <Card
                          iconGroup={iconGroup}
                          className="cinema-result-card"
                          img={imgUrl(item.thumb_image)}
                          variant="boxless"
                          imgRatio="r-4-3"
                          title={item[`title_${locale}`]}
                          text={
                            <>
                              <p>{item?.excerpt_id}</p>
                              <p>{item?.address}</p>
                              <p>{item?.city?.name}</p>
                            </>
                          }
                          onClick={() => {
                            dataLayerCinemaLocation({
                              event: "cinema_location",
                              cinema_name: item[`title_${locale}`],
                              cinema_city: item?.city?.name,
                            })
                            Router.push(`/locations/${item.slug}`)
                          }}
                        >
                          <Link
                            href={`/locations/${item.slug}`}
                            className="text-capitalize"
                            withArrow
                          >
                            {translations[`view_detail_${locale}`]}
                          </Link>
                        </Card>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </SliderSwiper>
            ) : (
              <SectionNotFound
                title={translations[`not_found_cinema_title_${Router.locale}`]}
                text={translations[`not_found_cinema_text_${Router.locale}`]}
              />
            )
          ) : (
            <div className="loading-dots-wrapper">
              <h1 className="loading-dots">Loading</h1>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

function SectionFindCinema({ className = "", title, concessionId, cinemaId }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className={`sc-find-cinema ${className}`} ref={trigger}>
      <Geolocation
        render={({
          fetchingPosition,
          error,
          getCurrentPosition,
          position: { coords: { latitude, longitude } = {} } = {},
        }) => (
          <SectionFindCinema1
            anim={anim}
            error={error}
            title={title}
            cinemaId={cinemaId}
            latitude={latitude}
            longitude={longitude}
            concessionId={concessionId}
            fetchingPosition={fetchingPosition}
            getCurrentPosition={getCurrentPosition}
          />
        )}
      />
    </section>
  )
}

export default SectionFindCinema
